module.exports = __webpack_public_path__ + "img/S@2x.00c200f.webp";